<template>
    <!-- External URL -->
    <a :href="externalUrl" v-if="externalUrl" class="link" target="_blank" @click="$emit('click')">
      <svgicon v-if="icon" :src="icon" class="icon" width="20" height="20"/>
      <div class="dot" v-if="dot"></div>
      <slot></slot>
    </a>

    <!-- Internal URL -->
    <router-link :to="customUrl || $router.buildContext(url)" class="link" v-else-if="url || customUrl" @click.native="$emit('click')">
        <svgicon v-if="icon" :src="icon" class="icon" width="20" height="20"/>
        <div class="dot" v-if="dot"></div>
        <slot></slot>
    </router-link>
</template>

<script>
    export default {
      name: "NavigationLink",

      props: {
        url: String,
        externalUrl: String,
        customUrl: Object,
        icon: String,
        dot: Boolean
      }
    }
</script>

<style lang="scss" scoped>
    .dot {
        width: 10px;
        height: 10px;
        border: 2px solid #404040;
        border-radius: 10px;
        margin-right: 10px;
        margin-left: 10px;
        flex-shrink: 0;
    }
    .icon {
        margin-right: 30px;
        flex-shrink: 0;
    }
    .svgicon {
        fill: #404040;
    }
</style>

<style lang="scss">
    #navigation {
        .link {
            display: flex;
            align-items: center;
            text-decoration: none;
            flex-shrink: 0;
            font-size: 16px;
            color: #808080;
            border-bottom: 1px solid #262626;
            cursor: pointer;
            padding: 15px 20px;

          & > .holder > .link {
            padding: 0;
            font-size: inherit;
            color: inherit;
            flex-grow: 1;
          }

            &.router-link-exact-active {
                color: #fff;
                .svgicon {
                    fill: var(--primary-color);
                }
                .dot {
                    border-color: var(--primary-color);
                    background-color: var(--primary-color);
                }
            }
            .title {
                flex-grow: 1;
            }
        }
    }
</style>